import React, { useContext, useEffect, useMemo, useState, useRef } from 'react';
import { useTheme } from '@mui/material/styles';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Button,
  Container,
  Grid,
  IconButton,
  MenuItem,
  Stack,
  styled,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableCell,
  TablePagination,
  TableRow,
  tableCellClasses,
  Paper,
  TextField,
  Typography,
  Chip,
  Tooltip,
  Checkbox,
  InputAdornment,
  Dialog,
  DialogContent,
} from '@mui/material';
import moment from 'moment';
import { saveAs } from 'file-saver';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { CalendarToday } from '@mui/icons-material';
import FormGroup from '@mui/material/FormGroup';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import FormControlLabel from '@mui/material/FormControlLabel';
import axios from '../../utils/axios';
import UIContext from '../../context/UIContext';
import NoResultsFound from '../../components/NoResultsFound';
import ComplaintAdd from '../Transactions/Common/ComplaintAdd';
// Then at the top of your component:

const StyledTableCell = styled(TableCell)({
  color: 'white',
  fontWeight: '600',
  minWidth: '150px',
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#4379F2',
  },
  whiteSpace: 'nowrap',
});

const statusOptions = [
  { label: 'All', value: '0' },
  { label: 'Acknowledge', value: 'Acknowledge' },
  { label: 'Pending', value: 'Pending' },
  { label: 'Terminated', value: 'Terminated' },
];

const searchByOptions = [
  { label: 'Phone Number', value: 'phonenumber' },
  { label: 'Ledger', value: 'ledger' },
  { label: 'Email ID', value: 'emailid' },
];

const shipmentTypeOptionsUK = [
  { label: 'All', value: 0 },
  { label: 'Air Cargo', value: 'courier' },
  { label: 'Sea Cargo', value: 'cargo' },
];

const shipmentTypeOptionsIN = [{ label: 'Air Cargo', value: 'courier' }];

const complaintFromOptions = [
  { label: 'All', value: 'All' },
  { label: 'Customer', value: 'Customer' },
  { label: 'Admin', value: 'Admin' },
  { label: 'SE', value: 'SE' },
];

function ComplaintReview() {
  const theme = useTheme();
  const shipmentTypeRef = useRef(null);
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);
  const [expanded, setExpanded] = useState(true);
  const [branchList, setBranchList] = useState([]);
  const [ledgerPhoneFilterData, setLedgerPhoneFilterData] = useState([]);
  const [getDataForView, setGetDataForView] = useState([]);
  const [salesExecutiveFilterData, setSalesExecutiveFilterData] = useState([]);
  const [acknowledgedByFilterData, setAcknowledgedByFilterData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isActive, setIsActive] = useState(false);
  const [orderNoCollection, setOrderNoCollection] = useState([]);
  const [filterInputs, setFilterInputs] = useState({
    fromDate: moment().startOf('month').format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
    Branch: '',
    status: '0',
    ledger: '',
    salesExecutive: '',
    searchBy: 'phonenumber',
    shipmentType: sessionStorage.getItem('country') === 'UK' ? 0 : 'courier',
    selectedBookOrder: null,
    senderCountry: '',
    receiverCountry: '',
    acknowledgedBy: '',
    complaintFrom: 'All',
  });
  const [countryList, setCountryList] = useState([]);
  const [dateFilterEnabled, setDateFilterEnabled] = useState(false);
  const [isComplaintDialogOpen, setComplaintDialogOpenState] = useState(false);
  const [complaintDetail, setComplaintDetail] = useState({
    courierCargoId: '',
    shipmentType: '',
    userType: sessionStorage.getItem('userRole') === 'Sales' ? 'SE' : 'Admin',
    complaintId: '',
  });
  const [formErrors, setFormErrors] = useState({
    fromDate: '',
    toDate: '',
  });

  const handleDateFilterToggle = (event) => {
    setDateFilterEnabled(event.target.checked);
  };

  const closeComplaintDialog = () => {
    setComplaintDialogOpenState(false);
  };

  const openComplaintDialog = (orderId, shipType, ComplaintId) => {
    setComplaintDetail((prev) => ({
      ...prev,
      courierCargoId: orderId,
      shipmentType: shipType,
      complaintId: ComplaintId,
    }));
    setComplaintDialogOpenState(true);
  };

  const getAllData = async () => {
    if (!validateFilters()) {
      return; // If validation fails, stop the request
    }
    try {
      showLoading();
      const config = {
        headers: {
          Country: sessionStorage.getItem('country'),
        },
      };
      const apiCalls = [];
      if (filterInputs.shipmentType === 0) {
        apiCalls.push(
          axios.post(
            'Complaint/ComplaintCommon/GetAllCargoComplaintReview',
            {
              ledgerId: filterInputs.ledger?.CUSTOMERID || 0,
              BranchId: filterInputs.Branch?.BranchId || 0,
              shipmentType: filterInputs.shipmentType || 0,
              BookOrderId: filterInputs.selectedBookOrder?.OrderId || 0,
              salesExecutiveId: filterInputs.salesExecutive?.salesPersonId || 0,
              dateFilter: dateFilterEnabled ? 'Booking' : 'Complaint',
              fromDate: moment(filterInputs.fromDate).format('YYYYMMDD'),
              toDate: moment(filterInputs.toDate).format('YYYYMMDD'),
              status: filterInputs.status,
              senderCountryId: filterInputs.senderCountry?.CountryId || 0,
              receiverCountryId: filterInputs.receiverCountry?.CountryId || 0,
              userId: sessionStorage.getItem('UserId'),
              complaintFrom: filterInputs.complaintFrom || 'All',
              acknowledgedById: filterInputs.acknowledgedBy?.salesPersonId || 0,
            },
            config
          )
        );
        apiCalls.push(
          axios.post(
            'Complaint/ComplaintCommon/GetAllCourierComplaintReview',
            {
              ledgerId: filterInputs.ledger?.CUSTOMERID || 0,
              BranchId: filterInputs.Branch?.BranchId || 0,
              shipmentType: filterInputs.shipmentType || 0,
              BookOrderId: filterInputs.selectedBookOrder?.OrderId || 0,
              salesExecutiveId: filterInputs.salesExecutive?.salesPersonId || 0,
              dateFilter: dateFilterEnabled ? 'Booking' : 'Complaint',
              fromDate: moment(filterInputs.fromDate).format('YYYYMMDD'),
              toDate: moment(filterInputs.toDate).format('YYYYMMDD'),
              status: filterInputs.status,
              senderCountryId: filterInputs.senderCountry?.CountryId || 0,
              receiverCountryId: filterInputs.receiverCountry?.CountryId || 0,
              userId: sessionStorage.getItem('UserId'),
              complaintFrom: filterInputs.complaintFrom || 'All',
              acknowledgedById: filterInputs.acknowledgedBy?.salesPersonId || 0,
            },
            config
          )
        );
      } else {
        const shiptype =
          filterInputs.shipmentType === 'courier' ? 'GetAllCourierComplaintReview' : 'GetAllCargoComplaintReview';
        apiCalls.push(
          axios.post(
            `Complaint/ComplaintCommon/${shiptype}`,
            {
              ledgerId: filterInputs.ledger?.CUSTOMERID || 0,
              BranchId: filterInputs.Branch?.BranchId || 0,
              shipmentType: filterInputs.shipmentType || 0,
              BookOrderId: filterInputs.selectedBookOrder?.OrderId || 0,
              salesExecutiveId: filterInputs.salesExecutive?.salesPersonId || 0,
              dateFilter: dateFilterEnabled ? 'Booking' : 'Complaint',
              fromDate: moment(filterInputs.fromDate).format('YYYYMMDD'),
              toDate: moment(filterInputs.toDate).format('YYYYMMDD'),
              status: filterInputs.status,
              senderCountryId: filterInputs.senderCountry?.CountryId || 0,
              receiverCountryId: filterInputs.receiverCountry?.CountryId || 0,
              userId: sessionStorage.getItem('UserId'),
              complaintFrom: filterInputs.complaintFrom || 'All',
              acknowledgedById: filterInputs.acknowledgedBy?.salesPersonId || 0,
            },
            config
          )
        );
      }
      const responses = await Promise.all(apiCalls);
      // const data = responses.reduce((prev, curr) => [...prev, ...curr.data], []);
      const data = responses
        .reduce((prev, curr) => [...prev, ...curr.data], [])
        .sort((a, b) => new Date(b.complaint_date) - new Date(a.complaint_date))
        .map((item, index) => ({
          ...item,
          SNo: index + 1, // Reset SNo sequentially
        }));
      if (getDataForView.length === 0 && data.length !== 0) setGetDataForView([]);
      setGetDataForView(data);
    } catch (e) {
      openSnackBar('Something went wrong! Try again.', 'error');
      setGetDataForView([]);
    }
    hideLoading();
  };

  const GetOrderFollowupTrackerExcel = async () => {
    if (!validateFilters()) {
      return; // If validation fails, stop the request
    }
    try {
      showLoading();
      const config = {
        headers: {
          Country: sessionStorage.getItem('country'),
        },
      };
      const response = await axios.post(
        `Complaint/ComplaintCommon/ComplaintReviewExcelExport`,
        {
          ledgerId: filterInputs.ledger?.CUSTOMERID || 0,
          BranchId: filterInputs.Branch?.BranchId || 0,
          shipmentType: filterInputs.shipmentType || 0,
          BookOrderId: filterInputs.selectedBookOrder?.OrderId || 0,
          salesExecutiveId: filterInputs.salesExecutive?.salesPersonId || 0,
          dateFilter: dateFilterEnabled ? 'Booking' : 'Complaint',
          fromDate: moment(filterInputs.fromDate).format('YYYYMMDD'),
          toDate: moment(filterInputs.toDate).format('YYYYMMDD'),
          status: filterInputs.status,
          senderCountryId: filterInputs.senderCountry?.CountryId || 0,
          receiverCountryId: filterInputs.receiverCountry?.CountryId || 0,
          userId: sessionStorage.getItem('UserId'),
          BranchName: filterInputs.Branch?.BranchName || '',
          OrderNo: filterInputs.selectedBookOrder?.OrderNo || '',
          searchby: filterInputs.searchBy,
          ledger: filterInputs.ledger?.CUSTOMERNAME || '',
          phonenumber: filterInputs.ledger?.Phone || '',
          salesExecutiveName: filterInputs.salesExecutive?.salesPersonName || '',
          senderCountryName: filterInputs.senderCountry?.CountryName || '',
          receiverCountryName: filterInputs.receiverCountry?.CountryName || '',
          complaintFrom: filterInputs.complaintFrom || 'All',
          acknowledgedById: filterInputs.acknowledgedBy?.salesPersonId || 0,
          acknowledgedBy: filterInputs.acknowledgedBy?.salesPersonName || '',
        },
        { responseType: 'blob', ...config }
      );

      const excelBlob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      });
      saveAs(excelBlob, `Complaint Review-${moment(new Date()).format('MMMM Do YYYY, h-mm a')}`);
      setTimeout(() => {
        hideLoading();
      }, 2000);
    } catch (error) {
      if (error.response?.status === 404) {
        openSnackBar('No records found to export.', 'error');
      } else {
        openSnackBar('Something went wrong! Try again.', 'error');
      }
    }
    hideLoading();
  };

  const validateFilters = () => {
    const errors = {};
    // Validate fromDate: should not be empty
    if (!filterInputs.fromDate) {
      errors.fromDate = 'From date is required';
    } else if (!moment(filterInputs.fromDate, 'YYYY-MM-DD', true).isValid()) {
      errors.fromDate = 'Invalid date format';
    }

    // Validate toDate: should not be empty and be a valid date
    if (!filterInputs.toDate) {
      errors.toDate = 'To date is required';
    } else if (!moment(filterInputs.toDate, 'YYYY-MM-DD', true).isValid()) {
      errors.toDate = 'Invalid date format';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0; // Return true if no errors
  };

  const handleFilterInputs = (e) => {
    setFilterInputs({
      ...filterInputs,
      [e.target.name]: e.target.value,
    });
  };

  const GetAllHelpData = async () => {
    try {
      showLoading();
      const userID = sessionStorage.getItem('UserId');
      const userRole = sessionStorage.getItem('userRole');
      const companyId = 4;

      const config = {
        headers: {
          Country: sessionStorage.getItem('country'),
        },
      };

      let customerHelpUrl = '';
      let salesExcutiveUrl = '';

      if (userRole === 'Admin') {
        customerHelpUrl = '/master/customer/GetCustomerHelp/4';
        salesExcutiveUrl = '/Approval/LoginApprovalRoute/GetAllSalesExecutive';
      } else {
        customerHelpUrl = `/Transactions/SalesControls/GetCustomerHelpForSE/${companyId}/${userID}/0`;
        salesExcutiveUrl = `/Approval/LoginApprovalRoute/GetAllAssignedSalesExecutive/${sessionStorage.getItem(
          'UserId'
        )}`;
      }

      const [ledgerResponse, salesExecutiveResponse] = await Promise.all([
        axios.get(customerHelpUrl, config),
        axios.get(salesExcutiveUrl, config),
      ]);
      setLedgerPhoneFilterData(ledgerResponse.data);
      setSalesExecutiveFilterData(salesExecutiveResponse.data);
      setAcknowledgedByFilterData(salesExecutiveResponse.data);
    } catch (e) {
      openSnackBar('Something Went Wrong', 'error');
    }
    hideLoading();
  };

  async function GetBranchList(cntry) {
    try {
      const requestData = {
        CompanyId: sessionStorage.getItem('CompanyId'),
      };

      const config = {
        headers: {
          Country: cntry,
        },
      };
      showLoading();
      let response;
      if (sessionStorage.getItem('userRole') === 'Admin') {
        response = await axios.post('signup/GetBranchList', requestData, config);
      } else {
        response = await axios.post(
          'Approval/LoginApprovalRoute/GetBranchLog',
          {
            UserId: sessionStorage.getItem('UserId'),
          },
          config
        );
      }
      const data = response.data.filter((i) => i.webBranch === 'Y');
      setBranchList(data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  const GetCountryList = async () => {
    try {
      const res = await axios.post('/signup/GetCountryList');
      const countries = res.data || [];
      const origin = (sessionStorage.getItem('Origin') || '').toUpperCase();
      const senderCountry = countries.find((country) => {
        const countryName = (country.CountryName || '').trim().toUpperCase();
        const countryCode = (country.CountryCode || '').trim();

        if (origin === 'IN') {
          return countryName === 'INDIA' || Number(country.CountryId) === 25 || countryCode === '8025';
        }
        if (origin === 'SL') {
          return countryName === 'SRI LANKA' || countryName === 'SRILANKA' || Number(country.CountryId) === 24 || countryCode === '8024';
        }
        if (origin === 'UK') {
          return countryName === 'UK' || countryName === 'UNITED KINGDOM' || Number(country.CountryId) === 232 || countryCode === '8232';
        }
        return false;
      });

      setCountryList(countries);
      if (senderCountry) {
        setFilterInputs((prev) => ({
          ...prev,
          senderCountry: prev.senderCountry || senderCountry,
        }));
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  async function GetAllOrderNo(shiptype, value) {
    showLoading();
    try {
      const CustomerId = value.CUSTOMERID || filterInputs.ledger?.CUSTOMERID || 0;
      if (shiptype === 'courier' || shiptype === 'cargo') {
        const response = await axios.post('Complaint/ComplaintCommon/GetAllCourierCargoComplaintBookingNo', {
          shipmentType: shiptype,
          customerId: CustomerId,
          routeType: 'ComplaintReview',
        });
        setOrderNoCollection(response.data);
      } else {
        setOrderNoCollection([]);
      }
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  useEffect(() => {
    getAllData();
    GetAllHelpData();
    GetCountryList();
    GetBranchList(sessionStorage.getItem('Origin'));
  }, []);

  // pagination
  const { totalRows, currentPage } = useMemo(() => {
    const totalRows = getDataForView.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);

    return { totalRows, currentPage };
  }, [getDataForView, page, rowsPerPage]);

  return (
    <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
      <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
        <Typography
          variant="h5"
          p={1}
          boxShadow={1}
          borderColor="#11235A"
          textAlign={'center'}
          borderRadius={2}
          pl={2}
          color="white"
          sx={{
            // borderRadius: 50,
            background: '#8EACCD',
            boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
          }}
        >
          <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
            Complaint Review
          </Typography>
        </Typography>
      </Grid>
      <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4, my: 2 }}>
        <Accordion
          expanded={expanded}
          onChange={() => {
            setExpanded((expand) => !expand);
          }}
          disableGutters
          sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit' }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon style={{ color: '#8EACCD' }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={{ borderTop: 'none' }}
          >
            <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
              <IconButton aria-label="ExpandMoreIcon" color="#8EACCD">
                <FilterAltIcon style={{ color: '#8EACCD', width: 24, height: 24 }} />
              </IconButton>
              <Typography
                sx={{
                  color: '#8EACCD',
                  '&.active': {
                    color: 'text.primary',
                    bgcolor: 'action.selected',
                    fontWeight: 'fontWeightBold',
                  },
                }}
                variant="h6"
              >
                Filters
              </Typography>
            </Stack>
          </AccordionSummary>

          <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
            <Grid container spacing={2} p={1} pt={0} mb={0.5} rowSpacing={2} columnSpacing={1}>
              <Grid item md={2} xs={12}>
                {/* Search by Filter */}
                <TextField
                  fullWidth
                  select
                  label="Search by"
                  name="searchBy"
                  value={filterInputs.searchBy}
                  onChange={(e) => {
                    setFilterInputs({
                      ...filterInputs,
                      ledger: '',
                      searchBy: e.target.value,
                    });
                  }}
                  variant="outlined"
                  size="small"
                >
                  {searchByOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item md={4} xs={12}>
                <Autocomplete
                  key={filterInputs.searchBy}
                  options={ledgerPhoneFilterData}
                  getOptionLabel={(customer) => {
                    if (!customer) return '';
                    if (filterInputs.searchBy === 'phonenumber') return customer.Phone || '';
                    if (filterInputs.searchBy === 'emailid')
                      return customer.EmailId || customer.emailId || customer.EMAILID || '';
                    return customer.CUSTOMERNAME || '';
                  }}
                  renderOption={(props, customer) => (
                    <li {...props} key={customer.CUSTOMERID}>
                      {filterInputs.searchBy === 'phonenumber'
                        ? customer.Phone || ''
                        : filterInputs.searchBy === 'emailid'
                          ? customer.EmailId || customer.emailId || customer.EMAILID || ''
                          : customer.CUSTOMERNAME || ''}
                    </li>
                  )}
                  isOptionEqualToValue={(customer) => customer.CUSTOMERID === filterInputs.ledger?.CUSTOMERID}
                  value={filterInputs.ledger || null}
                  name="ledger"
                  onChange={(event, value) => {
                    setFilterInputs({
                      ...filterInputs,
                      ledger: value,
                    });
                    GetAllOrderNo(filterInputs.shipmentType, value);
                  }}
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        filterInputs.searchBy === 'phonenumber'
                          ? 'Phone Number'
                          : filterInputs.searchBy === 'emailid'
                            ? 'Email ID'
                            : 'Ledger'
                      }
                    />
                  )}
                />
              </Grid>
              <Grid item md={2} xs={12}>
                {/* Branch */}
                <Autocomplete
                  options={branchList} // Use branchList as options
                  getOptionLabel={(branch) => branch.BranchName} // Display branch names
                  renderOption={(props, branch) => (
                    <li {...props} key={branch.Branch}>
                      {branch.BranchName}
                    </li>
                  )}
                  isOptionEqualToValue={(option, value) => option.Branch === value?.Branch}
                  value={filterInputs.Branch || null} // Select branch from filterInputs
                  name="Branch"
                  onChange={(event, value) => {
                    setFilterInputs({ ...filterInputs, Branch: value });
                  }}
                  size="small"
                  renderInput={(params) => <TextField {...params} label="Branch" variant="outlined" />}
                />
              </Grid>
              {/* Shipment Type */}
              <Grid item md={2} xs={12}>
                <TextField
                  fullWidth
                  select
                  label="Shipment Type"
                  name="shipmenttype"
                  value={filterInputs.shipmentType}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    setFilterInputs((prevState) => ({
                      ...prevState,
                      shipmentType: e.target.value,
                      selectedBookOrder: Number(e.target.value) === 0 ? null : prevState.selectedBookOrder,
                    }));
                    GetAllOrderNo(e.target.value, 0);
                  }}
                  variant="outlined"
                  size="small"
                  inputRef={shipmentTypeRef}
                >
                  {sessionStorage.getItem('country') === 'UK'
                    ? shipmentTypeOptionsUK.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))
                    : shipmentTypeOptionsIN.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                </TextField>
              </Grid>
              {/* Booking No */}
              <Grid item md={2} xs={12}>
                <Autocomplete
                  key={filterInputs.searchBy}
                  options={orderNoCollection}
                  getOptionLabel={(option) => option.OrderNo}
                  renderOption={(props, option) => (
                    <li {...props} key={option.OrderId}>
                      {option.OrderNo}
                    </li>
                  )}
                  isOptionEqualToValue={(option, value) => option.OrderId === value?.OrderId}
                  value={filterInputs.selectedBookOrder}
                  onChange={(event, value) => {
                    setFilterInputs({
                      ...filterInputs,
                      selectedBookOrder: value,
                    });
                  }}
                  size="small"
                  renderInput={(params) => <TextField {...params} label="Booking No" />}
                />
              </Grid>
              {/* Sales Executive */}
              <Grid item md={3} xs={12}>
                <Autocomplete
                  options={salesExecutiveFilterData}
                  getOptionLabel={(salesPerson) => salesPerson.salesPersonName}
                  renderOption={(props, salesPerson) => (
                    <li {...props} key={salesPerson.salesPersonId}>
                      {salesPerson.salesPersonName}
                    </li>
                  )}
                  isOptionEqualToValue={(salesPerson) =>
                    salesPerson.salesPersonId === filterInputs.salesExecutive.salesPersonId
                  }
                  value={filterInputs.salesExecutive || null}
                  name="salesExecutive"
                  onChange={(event, value) => {
                    setFilterInputs({ ...filterInputs, salesExecutive: value });
                  }}
                  size="small"
                  renderInput={(params) => <TextField {...params} label="Sales Executive" />}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={dateFilterEnabled}
                      onChange={handleDateFilterToggle}
                      name="dateFilter"
                      color="primary"
                    />
                  }
                  label={`Filter by ${dateFilterEnabled ? 'Booking' : 'Complaint'} Dates`}
                  labelPlacement="start"
                  sx={{ marginRight: 0 }}
                />
              </Grid>
              {/* From Date */}
              <Grid item md={2} xs={12}>
                <TextField
                  fullWidth
                  label={dateFilterEnabled ? 'From Booking Date' : 'From Complaint Date'}
                  type="date"
                  name="fromDate"
                  value={filterInputs.fromDate}
                  onChange={handleFilterInputs}
                  InputLabelProps={{
                    shrink: true,
                    style: {
                      color: dateFilterEnabled ? theme.palette.primary.main : theme.palette.text.primary,
                    },
                  }}
                  variant="outlined"
                  size="small"
                  error={!!formErrors.fromDate}
                  helperText={formErrors.fromDate}
                  inputProps={{ max: '9999-12-31' }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderColor: dateFilterEnabled ? theme.palette.primary.main : undefined,
                    },
                  }}
                />
              </Grid>
              {/* To Date */}
              <Grid item md={2} xs={12}>
                <TextField
                  fullWidth
                  label={dateFilterEnabled ? 'To Booking Date' : 'To Complaint Date'}
                  type="date"
                  name="toDate"
                  value={filterInputs.toDate}
                  onChange={handleFilterInputs}
                  InputLabelProps={{
                    shrink: true,
                    style: {
                      color: dateFilterEnabled ? theme.palette.primary.main : theme.palette.text.primary,
                    },
                  }}
                  variant="outlined"
                  size="small"
                  error={!!formErrors.toDate}
                  helperText={formErrors.toDate}
                  inputProps={{ max: '9999-12-31' }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderColor: dateFilterEnabled ? theme.palette.primary.main : undefined,
                    },
                  }}
                />
              </Grid>
              {/* Status */}
              <Grid item md={2} xs={12}>
                <TextField
                  fullWidth
                  select
                  label="Status"
                  name="status"
                  value={filterInputs.status}
                  onChange={handleFilterInputs}
                  variant="outlined"
                  size="small"
                >
                  {statusOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item md={3} xs={12}>
                <Autocomplete
                  options={countryList || []}
                  getOptionLabel={(country) => country.CountryName || ''}
                  renderOption={(props, country) => (
                    <li {...props} key={country.CountryId}>
                      {country.CountryName}
                    </li>
                  )}
                  isOptionEqualToValue={(option, value) => option?.CountryId === value?.CountryId}
                  value={filterInputs.senderCountry || null}
                  name="senderCountry"
                  disabled
                  onChange={(event, value) => {
                    setFilterInputs({ ...filterInputs, senderCountry: value });
                  }}
                  size="small"
                  renderInput={(params) => <TextField {...params} label="Sender Country" />}
                />
              </Grid>
              <Grid item md={3} xs={12}>
                <Autocomplete
                  options={countryList || []}
                  getOptionLabel={(country) => country.CountryName || ''}
                  renderOption={(props, country) => (
                    <li {...props} key={country.CountryId}>
                      {country.CountryName}
                    </li>
                  )}
                  isOptionEqualToValue={(option, value) => option?.CountryId === value?.CountryId} // Compare options
                  value={filterInputs.receiverCountry || null}
                  name="receiverCountry"
                  onChange={(event, value) => {
                    setFilterInputs({ ...filterInputs, receiverCountry: value });
                  }}
                  size="small"
                  renderInput={(params) => <TextField {...params} label="Receiver Country" />}
                />
              </Grid>
              {/* AcknowledgedBy */}
              <Grid item md={3} xs={12}>
                <Autocomplete
                  options={acknowledgedByFilterData}
                  getOptionLabel={(salesPerson) => salesPerson.salesPersonName}
                  renderOption={(props, salesPerson) => (
                    <li {...props} key={salesPerson.salesPersonId}>
                      {salesPerson.salesPersonName}
                    </li>
                  )}
                  isOptionEqualToValue={(salesPerson) =>
                    salesPerson.salesPersonId === filterInputs.acknowledgedBy.salesPersonId
                  }
                  value={filterInputs.acknowledgedBy || null}
                  name="AcknowledgedBy"
                  onChange={(event, value) => {
                    setFilterInputs({ ...filterInputs, acknowledgedBy: value });
                  }}
                  size="small"
                  renderInput={(params) => <TextField {...params} label="AcknowledgedBy" />}
                />
              </Grid>
              {/* Complaint From */}
              <Grid item md={3} xs={12}>
                <TextField
                  fullWidth
                  select
                  label="Complaint From"
                  name="complaintFrom"
                  value={filterInputs.complaintFrom}
                  onChange={(e) => {
                    const { value } = e.target;
                    setFilterInputs((prevState) => ({
                      ...prevState,
                      complaintFrom: value,
                    }));
                  }}
                  variant="outlined"
                  size="small"
                >
                  {complaintFromOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2, mb: 2 }}>
                {/* View Button */}
                <Grid item xs={6} sm={3} md={2} lg={1}>
                  <Button variant="contained" color="primary" onClick={getAllData} fullWidth sx={{ boxShadow: 0 }}>
                    View
                  </Button>
                </Grid>

                {/* Excel Button */}
                {sessionStorage.getItem('userRole') !== 'Sales' && (
                <Grid item xs={6} sm={3} md={2} lg={1}>
                  <Button
                    variant="contained"
                    sx={{
                      color: 'white',
                      backgroundColor: '#118a27',
                      '&:hover': { backgroundColor: '#0e7320' }, // Optional: Hover effect
                    }}
                    onClick={GetOrderFollowupTrackerExcel}
                    fullWidth
                  >
                    Excel
                  </Button>
                </Grid>
                )}
              </Grid>
            </Grid>
            {getDataForView.length > 0 ? (
              <>
                <TableContainer component={Paper} elevation={2} sx={{ bgcolor: 'inherit', maxHeight: 600 }}>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell align="center">S.No</StyledTableCell>
                        <StyledTableCell align="center">Complaint Id</StyledTableCell>
                        <StyledTableCell align="center">Complaint Date</StyledTableCell>
                        <StyledTableCell align="center">Booking No</StyledTableCell>
                        <StyledTableCell align="center">Booking Date</StyledTableCell>
                        <StyledTableCell align="center">Customer</StyledTableCell>
                        <StyledTableCell align="center">Phone Number</StyledTableCell>
                        <StyledTableCell align="center">Complaint Reason</StyledTableCell>
                        <StyledTableCell align="center">Shipment Type</StyledTableCell>
                        <StyledTableCell align="center">Sender Country</StyledTableCell>
                        <StyledTableCell align="center">Receiver Country</StyledTableCell>
                        <StyledTableCell align="center">Branch</StyledTableCell>
                        <StyledTableCell align="center">Approval Status</StyledTableCell>
                        <StyledTableCell align="center">Current Status</StyledTableCell>
                        <StyledTableCell align="center">SalesExecutive</StyledTableCell>
                        <StyledTableCell align="center">Acknowledged By</StyledTableCell>
                        <StyledTableCell align="center">Complaint From</StyledTableCell>
                        <StyledTableCell align="center" sx={{ position: 'sticky', right: 0, zIndex: 2 }}>
                          Action
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(rowsPerPage > 0
                        ? getDataForView.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        : getDataForView
                      ).map((data, i) => (
                        <TableRow key={data.complaint_id} hover>
                          <TableCell align="center">{data.SNo}</TableCell>
                          <TableCell align="center">{data.complaint_id}</TableCell>
                          <TableCell align="center">{moment(data.complaint_date).format('DD-MM-YYYY')}</TableCell>
                          <TableCell align="center">{data.BookOrderNo}</TableCell>
                          <TableCell align="center">{moment(data.BookDate).format('DD-MM-YYYY')}</TableCell>
                          <TableCell align="center">{data.CustomerName}</TableCell>
                          <TableCell align="center">{data.Phone}</TableCell>
                          {/* <TableCell align="center">{data.complaint_reason}</TableCell> */}
                          <TableCell align="center">
                            <Tooltip title={data.complaint_reason || ''} placement="top" arrow>
                              <div
                                style={{
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  maxWidth: '150px', // adjust based on your table width
                                }}
                              >
                                {data.complaint_reason}
                              </div>
                            </Tooltip>
                          </TableCell>
                          <TableCell align="center">{data.shipment_type === 'SCSL' ? 'Cargo' : 'Courier'}</TableCell>
                          <TableCell align="center">{data.SenderCountry}</TableCell>
                          <TableCell align="center">{data.ReceiverCountry}</TableCell>
                          <TableCell align="center">{data.Branch_Name}</TableCell>
                          <TableCell align="center">{data.ApprovalStatus}</TableCell>
                          <TableCell align="center">{data.Status}</TableCell>
                          <TableCell align="center">{data.SalesExecutive}</TableCell>
                          <TableCell align="center">{data.AcknowledgedBy}</TableCell>
                          <TableCell align="center">{data.userType}</TableCell>
                          <TableCell
                            align="center"
                            sx={{ position: 'sticky', right: 0, bgcolor: '#F9FAFB', zIndex: 1, whiteSpace: 'nowrap' }}
                          >
                            <Button
                              variant="outlined"
                              color="error"
                              sx={{ boxShadow: 1, whiteSpace: 'nowrap' }}
                              onClick={() => {
                                openComplaintDialog(data.Book, data.shipment_type, data.complaint_id);
                              }}
                              size="small"
                              fullWidth
                              startIcon={<ReportGmailerrorredIcon fontSize="small" />}
                            >
                              View
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={totalRows}
                  rowsPerPage={rowsPerPage}
                  page={currentPage}
                  onPageChange={(event, newPage) => setPage(newPage)}
                  onRowsPerPageChange={(event) => {
                    setRowsPerPage(parseInt(event.target.value, 10));
                    setPage(0);
                  }}
                  mt={2}
                />
              </>
            ) : (
              <NoResultsFound />
            )}
          </AccordionDetails>
        </Accordion>
      </Stack>

      {/* Add Complaint Popup */}
      <Dialog fullWidth maxWidth={'md'} open={isComplaintDialogOpen} onClose={closeComplaintDialog}>
        <DialogContent>
          <ComplaintAdd
            setComplaintDialogOpenState={setComplaintDialogOpenState}
            complaintDetail={complaintDetail}
            getAllData={getAllData}
          />
        </DialogContent>
      </Dialog>
    </Container>
  );
}

export default ComplaintReview;
